// config.js
import materiali from "./materials-stuff.js"

export const material = materiali
export const defaultRivestimento = {
  slug: "",
  name: "",
  thumbnail: "",
}

// If found, set defaultStruttura to the material object
export const defaultStruttura = {
  slug: "",
  name: "",
  thumbnail: "",
}

export let defaultFinitura = {
  slug: "",
  name: "",
  thumbnail: "",
}

export let configuration = {
  rivestimento: defaultRivestimento.slug,
}
export let appliedConfiguration = `${configuration.rivestimento}`

// Define the mapping between wood finish and plastic color for Mary chair
const maryChairMapping = {
  "FRASSINO VERDE": "PPL VERDE",
  "FRASSINO NERO": "PPL NERO",
  "FRASSINO TINTA ROVERE NATURALE": "PPL ROVERE",
}

// Keep track of the current product code
let currentProductCode = ""

// Set the current product code
export function setCurrentProductCode(code) {
  currentProductCode = code
}

// Function to set a material with a Promise interface
function setMaterial(materialVariation, configurableMaterial) {
  return new Promise((resolve, reject) => {
    try {
      if (!window.emViewers || !window.emViewers["emersyaIframe"]) {
        console.error("Emersya viewer not initialized")
        reject(new Error("Emersya viewer not initialized"))
        return
      }

      window.emViewers["emersyaIframe"].setMaterials({
        materials: [
          {
            materialVariation: materialVariation.toUpperCase(),
            configurableMaterial: configurableMaterial,
          },
        ],
      })

      // Resolve after a short delay to allow the viewer to process the change
      setTimeout(resolve, 10)
    } catch (error) {
      console.error("Error setting material:", error)
      reject(error)
    }
  })
}

export function switchConfiguration(configurationName, type) {
  // Add basic check to prevent errors
  if (!window.emViewers || !window.emViewers["emersyaIframe"]) {
    console.error("Emersya viewer not initialized")
    return
  }

  let configurableMaterial = null

  // Normalize the type to uppercase for consistency
  const normalizedType = type.toUpperCase()

  if (normalizedType === "CUSCINO") {
    configuration.rivestimento = configurationName
    configurableMaterial = "CUSCINO"
    appliedConfiguration = `${configuration.rivestimento.slug}`
  } else if (normalizedType === "STRUTTURA") {
    configuration.struttura = configurationName
    configurableMaterial = ["STRUTTURA", "struttura"]
    appliedConfiguration = `${configuration.struttura.slug}`
  } else if (normalizedType === "IMBOTTITO") {
    configuration.rivestimento = configurationName
    configurableMaterial = ["imbottito", "IMBOTTITO"]
    appliedConfiguration = `${configuration.rivestimento.slug}`
  } else if (normalizedType === "FINITURA") {
    configuration.finitura = configurationName
    configurableMaterial = ["finitura", "FINITURA"]
    appliedConfiguration = `${configuration.finitura.slug}`
  } else if (/^imbottito_/i.test(type) || /^CUSCINO_/i.test(type)) {
    configuration.rivestimento = configurationName
    configurableMaterial = type
    appliedConfiguration = `${configuration.rivestimento.slug}`
  }


  try {
    // Get current configuration using .then() without .catch()
    const configPromise =
      window.emViewers["emersyaIframe"].getCurrentGlobalConfiguration()

    // Handle the Promise-like object with only .then() method
    configPromise.then(
      function handleSuccess(data) {
        try {
          const currentProject = Object.keys(data.projectsData)[0]
          const projectData = data.projectsData[currentProject]

          // Check materialTrees for actual keys
          const materialTreeKeys = Object.keys(projectData.materialTrees)

          // Find the matching key with case insensitive comparison
          let actualKey = null
          if (Array.isArray(configurableMaterial)) {
            for (const material of configurableMaterial) {
              const matchingKey = materialTreeKeys.find(
                (key) => key.toLowerCase() === material.toLowerCase()
              )
              if (matchingKey) {
                actualKey = matchingKey
                break
              }
            }
          } else if (typeof configurableMaterial === "string") {
            actualKey = materialTreeKeys.find(
              (key) => key.toLowerCase() === configurableMaterial.toLowerCase()
            )
          }

          // If we found a matching key, use it
          if (actualKey) {

            // Special handling for Mary chair (PAGZ5OH58N)
            if (
              normalizedType === "STRUTTURA" &&
              currentProductCode === "PAGZ5OH58N"
            ) {
              // Get the corresponding plastic color
              const selectedWoodFinish = appliedConfiguration.toUpperCase()
              const correspondingPlastic = maryChairMapping[selectedWoodFinish]

              if (correspondingPlastic) {
                // Find the plastic material tree key
                const plasticKey = materialTreeKeys.find(
                  (key) => key.toLowerCase() === "plastica"
                )

                if (plasticKey) {
                  // Use our new Promise-based function with proper sequencing
                  setMaterial(appliedConfiguration, actualKey)
                    .then(() => {
                      // Wait for the first material change to complete
                      // Add a longer delay before setting the plastic
                      return new Promise((resolve) => setTimeout(resolve, 300))
                    })
                    .then(() => {
                      // Now set the plastic material
                      return setMaterial(correspondingPlastic, plasticKey)
                    })
                    .then(() => {
                    })
                    .catch((error) => {
                      console.error(
                        "Error in material application sequence:",
                        error
                      )
                      // Fallback - try setting materials again with even longer delay
                      setTimeout(() => {
                        try {
                          setMaterial(appliedConfiguration, actualKey)
                          setTimeout(() => {
                            try {
                              setMaterial(correspondingPlastic, plasticKey)
                            } catch (e) {
                              console.error(
                                "Final fallback for plastic failed:",
                                e
                              )
                            }
                          }, 500)
                        } catch (e) {
                          console.error("Final fallback for wood failed:", e)
                        }
                      }, 500)
                    })

                  // Return early since we're handling this case specifically
                  return
                }
              }
            }

            // For non-Mary chair or if plastic key wasn't found, just set the main material
            setMaterial(appliedConfiguration, actualKey)
          } else {
            console.error(
              "No matching material tree key found for:",
              Array.isArray(configurableMaterial)
                ? configurableMaterial.join(", ")
                : configurableMaterial
            )

            // Fallback to direct configuration if we couldn't find a matching material tree key
            const defaultMaterial = Array.isArray(configurableMaterial)
              ? configurableMaterial[0]
              : configurableMaterial

            setMaterial(appliedConfiguration, defaultMaterial)
          }
        } catch (innerError) {
          console.error("Error processing configuration:", innerError)
        }
      },
      function handleError(error) {
        // This is our manual error handler since .catch() isn't available
        console.error("Error getting current configuration:", error)

        // Fallback to direct setting without checking materialTrees
        const defaultMaterial = Array.isArray(configurableMaterial)
          ? configurableMaterial[0]
          : configurableMaterial

        setMaterial(appliedConfiguration, defaultMaterial)
      }
    )
  } catch (error) {
    console.error("Error setting materials:", error)

    // Fallback to direct approach if everything else fails
    try {
      const defaultMaterial = Array.isArray(configurableMaterial)
        ? configurableMaterial[0]
        : configurableMaterial

      setMaterial(appliedConfiguration, defaultMaterial)
    } catch (finalError) {
      console.error("Final fallback failed:", finalError)
    }
  }
}
